package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.at.oss.kotlin.manual.storage.common.websites.WebsitesEntry
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Based on M1SS WebURLValidator.
 * Created by Pedro Alfaiate on 14/07/2020.
 */
object WebsitesValidator {

    /**
     * Expressão regular de um URL. Adaptado de http://regexlib.com/REDetails.aspx?regexp_id=1854 . Melhoramentos:
     *
     *  * torna o "http://" ou "https://" opcional.
     *  * permite que URLs cujo path não acabe no nome dum ficheiro com extensão tenham parâmetros i.e. "example.com?x=true", "example.com/?x=true",
     * "example.com/pagina?x=true" funcionam. Na original só funcionaria "example.com/pagina.php?x=true" porque procurava o '.'.
     *  * Permite URLs válidos mas "estúpidos", por exemplo, URLs que acabem em '?' ou em '&' depois do '?'. Permite também que variáveis de GET não tenham um
     * valor definido, i.e. "[...]?x=&y=&z=blabla".
     *
     */
    private val URL_PATTERN = Regex(
        "^(?:https?://)?" +
            // protocolo
            "[a-zA-Z0-9\\-_]+(?:\\.[a-zA-Z0-9\\-_]+)*\\.[a-zA-Z]{2,6}" +
            // domínio
            "(?:/?|(?:/[\\w\\-\\.]+/?)*)" +
            // path
            "(?:\\?|\\?[\\w]+(?:=[\\w\\-]*))?" +
            // 1º parâmetro
            "(?:&|&[\\w]+(?:=[\\w\\-]*))*$"
    ) // mais parâmetros

    val validateWebsite = fun(website: String): ValidationError? {
        return if (website.isNotEmpty() && !URL_PATTERN.matches(website)) ValidationError(code = CustomErrorCodes.WEBSITE_INVALID.code)
        else null
    }

    val validateWebsitesSequential = fun(websites: List<WebsitesEntry>, isMandatory: Boolean): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()

        if (isMandatory && websites.isEmpty()) {
            errors.add(ValidationError(code = CustomErrorCodes.WEBSITE_NOT_GIVEN.code))
        }

        websites.forEach { website ->
            validateWebsite(website.name)
                ?.also { errors.add(it) }
        }

        return errors
    }
}
